import { render, staticRenderFns } from "./PostalCodes.vue?vue&type=template&id=62481d1f"
import script from "./PostalCodes.vue?vue&type=script&lang=js"
export * from "./PostalCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports